export const LEGAL_ACCEPTANCE_ERROR_CODE = 'legal_acceptance_required'

const TERMS_URL = process.env.REACT_APP_TERMS_URL || 'https://terms.mred.com.br/'
const POLICY_URL = process.env.REACT_APP_POLICY_URL || 'https://policy.mred.com.br/'

export const LEGAL_DOCUMENTS = {
  terms: {
    key: 'terms',
    label: 'Termos de Uso',
    url: TERMS_URL,
    userField: 'is_terms_accepted',
  },
  privacy_policy: {
    key: 'privacy_policy',
    label: 'Política de Privacidade',
    url: POLICY_URL,
    userField: 'is_privacy_policy_accepted',
  },
} as const

export type LegalDocumentKey = keyof typeof LEGAL_DOCUMENTS

export const ALL_LEGAL_DOCUMENTS: LegalDocumentKey[] = ['terms', 'privacy_policy']

type FlattenedError = {
  code?: string
  detail?: string
  attr?: string | null
}

const isLegalDocumentKey = (value: string): value is LegalDocumentKey => value in LEGAL_DOCUMENTS

const readErrors = (body: unknown): FlattenedError[] | null => {
  if (!body || typeof body !== 'object') {
    return null
  }

  const errors = (body as { errors?: unknown }).errors

  if (!Array.isArray(errors)) {
    return null
  }

  return errors as FlattenedError[]
}

export const isLegalAcceptanceError = (body: unknown): boolean => {
  const errors = readErrors(body)

  if (!errors) {
    return false
  }

  return errors.some((error) => error?.code === LEGAL_ACCEPTANCE_ERROR_CODE)
}

export const pendingLegalDocuments = (body: unknown): LegalDocumentKey[] => {
  const errors = readErrors(body)

  if (!errors) {
    return ALL_LEGAL_DOCUMENTS
  }

  const pending = errors
    .filter((error) => error?.attr === 'documents')
    .map((error) => error.detail ?? '')
    .filter(isLegalDocumentKey)

  return pending.length > 0 ? pending : ALL_LEGAL_DOCUMENTS
}
